import { Stack } from '@mantine/core';
import { useMemo } from 'react';
import {
	SearchFilterV2Store,
	SearchFilterV2StoreContext,
} from '../../../Filter/store';
import { useCatalogFilter } from '../../../Filter/useCatalogFilter';
import { ApiFilterPreview } from './ApiFilterPreview';
import { FilterBar } from './FilterBar';

export function ApiFiltersGenerator() {
	const filters = useCatalogFilter();

	const store = useMemo(
		() =>
			new SearchFilterV2Store({
				filterOptions: filters,
			}),
		[filters]
	);

	return (
		<SearchFilterV2StoreContext.Provider value={store}>
			<Stack>
				<FilterBar />
				<ApiFilterPreview />
			</Stack>
		</SearchFilterV2StoreContext.Provider>
	);
}
